import axios from 'axios'
import { EsputnikService } from '@/services/AnalyticService'
import constants from '@/helpers/constants'

export default {
  state: {
    cart: {
      cost: null,
      quantity: 0,
      originCost: null
    },
    products: [],
    notUpdateCheckout: false,
    cartSort: [],
    showCartRtbHouseCode: false,
    promocodeInfo: null,
    clientProducts: null,
    clientEdrpous: []
  },
  getters: {
    cartSort: state => {
      let cartSortProducts = []

      state.cartSort.map(id => {
        cartSortProducts.push(state.products.find(product => product.id === id))
      })

      return {
        cart: { ...state.cart },
        products: cartSortProducts
      }
    },
    cartSortClient: state => {
      return {
        cart: { ...state.cart },
        products: state.clientProducts
      }
    },
    cartInfoForEcommerce: state => {
      const productsData = []

      if (state.products) {
        state.products.forEach(el => {
          let item
          if (el.analytics_data.length === 1) {
            if (state.promocodeInfo && state.promocodeInfo.codeValue) {
              const discount = el.price_old && el.price ? (parseFloat(el.price_old) - parseFloat(el.price)).toFixed(2) : 0
              item = { ...el.analytics_data[0], price: +el.price, discount: discount }
            } else {
              item = el.analytics_data[0]
            }
          } else {
            if (state.promocodeInfo && state.promocodeInfo.codeValue) {
              const discount = el.price_old && el.price ? (parseFloat(el.price_old) - parseFloat(el.price)).toFixed(2) : 0
              item = { ...el.analytics_data.find(el => el.is_main_product), price: +el.price, discount }
            } else {
              item = el.analytics_data.find(el => el.is_main_product)
            }
          }
          productsData.push({
            id: item.id,
            price: item.price,
            quantity: item.quantity * el.itemQuantity,
            category: item.category,
            name: item.name,
            discount: item.discount,
            categories: item.categories,
            name_uk: item.name_uk
          })
        })
      }

      return productsData
    },
    cartTotalPriceMoreThenTwoThousands: state => {
      return state.cart.originCost >= 2000
    }
  },
  mutations: {
    SET_CART: (state, cart) => {
      state.cart = cart.cart
      state.products = cart.products
      state.notUpdateCheckout = cart.notUpdateCheckout
    },
    SET_CART_SORT: (state, cartSort) => {
      state.cartSort = cartSort
      sessionStorage.setItem('cartSort', JSON.stringify(state.cartSort))
    },
    SET_CART_RTB_HOUSE_CODE_FLAG: (state, flag) => {
      state.showCartRtbHouseCode = flag
    },
    SET_PRODUCTS: (state, data) => {
      state.products = data
    },
    SET_PROMOCODE: (state, data) => {
      if (data) {
        state.cart = data.cart
        state.promocodeInfo = data
      }
    },
    SET_CLIENT_CART (state, cart) {
      state.clientProducts = cart
    },
    SET_CLIENT_EDRPOUS (state, data) {
      state.clientEdrpous = data
    }
  },
  actions: {
    GET_FULL_CART: ({ commit, dispatch, rootGetters, rootState }, { notUpdateCheckout = false, storeUid = null, deliveryType = null, bonuses = null } = {}) => {
      return new Promise((resolve, reject) => {
        let params = []
        const isCheckout = constants.IS_CHECKOUT() || rootState.checkout.isManagerPage
        const computedStoreUid = storeUid || rootState.checkout.formData.deliveryInfo?.deliverySpot?.uid
        if (computedStoreUid) {
          params.push('store_uid=' + storeUid)
        }
        if (bonuses) {
          params.push('debitingBonuses=' + bonuses)
        }
        if (deliveryType) {
          params.push('delivery_method_id=' + deliveryType)
        }

        if (rootState.checkout.isManagerPage && rootState.checkout.managersClientData?.phone) {
          params.push(`client_phone=${rootState.checkout.managersClientData.phone}`)
        }

        const paramsString = (params.length > 0) ? '?' + params.join('&') : ''

        if (isCheckout) {
          dispatch('SET_LOADING_COMPONENT', { bonusesInModal: true }, { root: true })
        }
        axios
          .post(rootGetters.urlLanguagePrefix + '/shop/cart/get-full-cart/' + paramsString)
          .then(response => {
            commit('SET_PROMOCODE', response.data.promo_data)
            const data = { ...response.data }
            if (notUpdateCheckout) data.notUpdateCheckout = true
            commit('SET_CART', data)
            commit('SET_CART_SORT', response.data.products.map(item => item.id))

            if (response.data.client_products) {
              commit('SET_CLIENT_CART', response.data.client_products)
            }

            if (response.data.client_edrpous) {
              commit('SET_CLIENT_EDRPOUS', response.data.client_edrpous)
            }

            if (response.data.bonusesInfo) {
              commit('SET_BONUSES_INFO_CART', response.data.bonusesInfo, { root: true })
              if (isCheckout) {
                dispatch('SET_LOADING_COMPONENT', { bonusesInModal: false }, { root: true })
              }
            }

            resolve(response.data)
          })
          .catch(error => reject(error))
      })
    },
    CHANGE_PRODUCT_QUANTITY: ({ commit, dispatch, getters, rootGetters, rootState }, payload) => {
      return new Promise((resolve, reject) => {
        commit('SET_LOADING_COMPONENTS', { cartItem: true })
        let params = []
        if (payload.storeUid) {
          params.push('store_uid=' + payload.storeUid)
        }
        if (payload.deliveryType) {
          params.push('delivery_method_id=' + payload.deliveryType)
        }
        if (payload.bonuses) {
          params.push('debitingBonuses=' + payload.bonuses)
        }

        const paramsString = (params.length > 0) ? '&' + params.join('&') : ''

        let url = rootGetters.urlLanguagePrefix + '/shop/cart/quantity/?id=' + payload.productHashId + '&quantity=' + payload.productQuantity + paramsString

        axios
          .post(url)
          .then(response => {
            commit('SET_CART', response.data)
            commit('SET_CART_SORT', response.data.products.map(item => item.id))
            commit('SET_LOADING_COMPONENTS', { cartItem: false })

            if (response.data.bonusesInfo) {
              const isCheckout = constants.IS_CHECKOUT() || rootState.checkout.isManagerPage
              commit('SET_BONUSES_INFO_CART', response.data.bonusesInfo, { root: true })
              if (isCheckout) {
                dispatch('SET_LOADING_COMPONENT', { bonusesInModal: false }, { root: true })
              }
            }

            // Отправка данных по корзине в Esputnik
            EsputnikService.sendStatusCartInfo({
              products: getters.cartInfoForEcommerce
            })

            resolve(response.data)
          })
          .catch(error => {
            commit('SET_LOADING_COMPONENTS', { cartItem: false })
            reject(error)
          })
      })
    },
    ADD_PRODUCT_TO_CART: ({ commit, getters, rootGetters, rootState }, payload) => {
      return new Promise((resolve, reject) => {
        let params = []

        if (payload.storeUid) {
          params.push('store_uid=' + payload.storeUid)
        }

        if (payload.storeId) {
          params.push('store_id=' + payload.storeId)
        }

        if (payload.deliveryType) {
          params.push('delivery_method_id=' + payload.deliveryType)
        }

        const paramsString = (params.length > 0) ? '&' + params.join('&') : ''
        let url = rootGetters.urlLanguagePrefix + '/shop/cart/add/?id=' + payload.productId + paramsString

        axios
          .post(url)
          .then(response => {
            if (response.data.error) {
              reject(response.data.error)
            } else {
              commit('SET_CART', response.data)
              commit('SET_CART_SORT', response.data.products.map(item => item.id))

              // Отправка данных по корзине в Esputnik
              if (payload.esputnikBlockId) {
                EsputnikService.sendProductPageInfo({ product: payload.esputnikData, blockId: payload.esputnikBlockId })
              }

              EsputnikService.sendStatusCartInfo({
                products: getters.cartInfoForEcommerce
              })

              resolve(response.data)
            }
          })
          .catch(error => reject(error))
      })
    },
    REMOVE_PRODUCT_FROM_CART: ({ commit, dispatch, getters, rootGetters, rootState }, payload) => {
      let params = []
      if (payload.storeUid) {
        params.push('store_uid=' + payload.storeUid)
      }
      if (payload.deliveryType) {
        params.push('delivery_method_id=' + payload.deliveryType)
      }
      if (payload.bonuses) {
        params.push('debitingBonuses=' + payload.bonuses)
      }

      const paramsString = (params.length > 0) ? '&' + params.join('&') : ''

      let url = rootGetters.urlLanguagePrefix + '/shop/cart/remove/?id=' + payload.hashId + paramsString

      return new Promise((resolve, reject) => {
        axios
          .post(url)
          .then(response => {
            commit('SET_CART', response.data)
            commit('SET_CART_SORT', response.data.products.map(item => item.id))
            if (response.data.bonusesInfo) {
              const isCheckout = constants.IS_CHECKOUT() || rootState.checkout.isManagerPage
              commit('SET_BONUSES_INFO_CART', response.data.bonusesInfo, { root: true })
              if (isCheckout) {
                dispatch('SET_LOADING_COMPONENT', { bonusesInModal: false }, { root: true })
              }
            }

            // Отправка данных по корзине в Esputnik
            EsputnikService.sendStatusCartInfo({
              products: getters.cartInfoForEcommerce
            })

            resolve(response.data)
          })
          .catch(error => reject(error))
      })
    },
    CHANGE_CART_RTB_HOUSE_CODE_FLAG: ({ commit }, flag) => {
      commit('SET_CART_RTB_HOUSE_CODE_FLAG', flag)
    },
    SET_CART_FOR_THANKYOU_PAGE: ({ commit }, payload) => {
      commit('SET_PRODUCTS', payload)
    },
    FETCH_PROMOCODE: (ctx, data) => {
      axios.get(ctx.rootGetters.urlLanguagePrefix + '/shop/cart/promo/', { params: { code: data } })
        .then(response => {
          let getFullCartParams = {}
          if (ctx.rootState.deliveryNew) {
            getFullCartParams = {
              storeUid: ctx.rootState.deliveryNew.formData?.selectedSpot?.uid || '',
              deliveryType: ctx.rootState.deliveryNew.formData?.deliveryType?.methodId || ''
            }
          } else {
            getFullCartParams = {
              storeUid: ctx.rootState.checkout.formData && ctx.rootState.checkout.formData.deliveryInfo && ctx.rootState.checkout.formData.deliveryInfo.deliverySpot ? ctx.rootState.checkout.formData.deliveryInfo.deliverySpot.uid : null,
              deliveryType: ctx.rootState.checkout.formData && ctx.rootState.checkout.formData.deliveryType ? ctx.rootState.checkout.formData.deliveryType.methodId : null
            }
          }

          ctx.dispatch('GET_FULL_CART', getFullCartParams)
          ctx.commit('SET_PROMOCODE', response.data)
        })
    }
  }
}
